import { IArrayGridFilter, IDynamicValue, IGridFilter, OrFiltersGroup, TeamsPlusMoreDynamicValues } from "@gtmhub/shared/components/grid-filtering-bar";
import { getCurrentUserId } from "@gtmhub/users/current-user-storage";

export function separateDynamicValuesForAllGroups(filters: OrFiltersGroup[]): OrFiltersGroup[] {
  return filters.map((filtersGroup) => separateDynamicValues(filtersGroup));
}

const dynamicValueTypesMap = {
  teamOrgPlusMembers: "teamOrg",
};

const separateDynamicValues = (filtersGroup: OrFiltersGroup): OrFiltersGroup => {
  return filtersGroup.reduce((prev: OrFiltersGroup, current: IGridFilter) => {
    if (current.fieldName === "sessionId" && (<IArrayGridFilter>current).dynamicValues?.some((filter) => filter.type === "activeSessions")) {
      prev.push({
        fieldName: "sessionId_activeSessions",
        value: [],
        dataType: "array",
        operator: "isOneOf",
      });

      // clear the active sessions dynamic definition to prevent sending all client-evaluted IDs as part of the request
      (<IArrayGridFilter>current).dynamicValues = (<IArrayGridFilter>current).dynamicValues.filter((filter) => filter.type !== "activeSessions");
    }

    if (
      (current.fieldName.includes("ownerIds") || current.fieldName.includes("watchers")) &&
      (<IArrayGridFilter>current).dynamicValues &&
      (<IArrayGridFilter>current).dynamicValues.length
    ) {
      const { fieldName, dataType, operator, value, dynamicValues } = <IArrayGridFilter>current;
      let copyDynamicVal: (IGridFilter | IDynamicValue)[] = [];

      const checkMeTagDynamicVal = dynamicValues.findIndex((el) => el.type === "me");
      if (checkMeTagDynamicVal >= 0) {
        const meDynamicValue = dynamicValues.splice(checkMeTagDynamicVal, 1)[0];
        meDynamicValue.evaluated = [getCurrentUserId()];
        copyDynamicVal = [...copyDynamicVal, meDynamicValue];
      }
      prev.push(<IArrayGridFilter>{ fieldName, dataType, operator, value, ...{ dynamicValues: copyDynamicVal } });

      dynamicValues.forEach((val) => {
        const nameDynamic = `${fieldName}_${dynamicValueTypesMap[val.type] || val.type}`;

        // Check if filter has already been added and we need to add only another value
        const filterIndex = prev.findIndex((el) => el.fieldName === nameDynamic);
        if (filterIndex >= 0) {
          (<string[]>prev[filterIndex].value).push((<TeamsPlusMoreDynamicValues>val).teamId);
          return;
        }

        // Check if 'myTeams' tag has been used. Than add only userId
        if (val.type === "myTeams") {
          prev.push({
            fieldName: nameDynamic,
            value: [getCurrentUserId()],
            dataType,
            operator,
          });
          return;
        }

        prev.push({
          fieldName: nameDynamic,
          dataType,
          operator,
          value: [(<TeamsPlusMoreDynamicValues>val).teamId],
        });
      });

      return prev;
    }

    return [...prev, current];
  }, []);
};
